import { render, staticRenderFns } from "./ActiveDepartments.vue?vue&type=template&id=39542d56&"
import script from "./ActiveDepartments.vue?vue&type=script&lang=js&"
export * from "./ActiveDepartments.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDepartments.vue?vue&type=style&index=0&id=39542d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports